import type { SVGProps } from 'react';

export const X = (props: SVGProps<SVGSVGElement>) => (
    <svg width='16' height='16' fill='currentColor' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='m9.414 8 4.293-4.293a.999.999 0 1 0-1.414-1.414L8 6.586 3.707 2.293a.999.999 0 1 0-1.414 1.414L6.586 8l-4.293 4.293a.999.999 0 1 0 1.414 1.414L8 9.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L9.414 8Z'
        />
    </svg>
);
